
<template>
    <div>
        <page-container :top-bar="topBar" :menu="menu"><c-filter v-if="filters && filters.length" class="expert-filters" :selections="filters" :primary-color="themeColor" mask-color="rgba(0, 0, 0, .4)" item-select-strategy="strict" type="list" @change="filterChangeFn"></c-filter><mars-view class="filters-box"></mars-view><mars-view v-if="loading"><c-loading class="loading"></c-loading></mars-view><mars-view v-else><mars-view class="order-wrapper"><mars-view v-if="order && order.length > 0"><mars-view><mars-view v-for="(card, index) in order" :key="index" class="order-card-wrapper"><order-card :data="card" :order-index="index" @del="delCardFn(index)"></order-card></mars-view></mars-view><mars-view v-if="bottomLoading" class="l-span-center"><mars-image class="bottom-loading-icon" :lazy-load="true" src="https://ss2.baidu.com/6ONYsjip0QIZ8tyhnq/it/u=2916203555,3196138030&fm=179&app=35&f=GIF?w=300&h=150&s=69C03262DFE7BB510C50D41B0000E0C1"></mars-image></mars-view></mars-view><no-content v-else txt="暂无订单记录"></no-content></mars-view></mars-view></page-container>
    </div>
</template>

<script>
import Container from "../../components/common/container.vue";
import OrderCard from "../../components/common/orderCard.vue";
import NoContent from "../../components/common/noContent.vue";
import Loading from "../../mars_modules/@baidu/mars-ui/dist/h5/components/Loading/Loading.vue";
import Filter from "../../mars_modules/@baidu/mars-ui/dist/h5/components/Filter/Filter.vue";
import { getData, request } from '../../static/utils/request.js';
import { act } from '../../static/utils/navigate.js';
import { reqPathTo } from '../../static/utils/env.js';
import { setPageInfoMenu } from '../../static/utils/setPageInfoMenu';
export default {
  components: {
    'page-container': Container,
    'c-filter': Filter,
    'order-card': OrderCard,
    'no-content': NoContent,
    'c-loading': Loading
  },
  data() {
    return {
      topBar: {
        title: '我的订单',
        color: '#000',
        bgColor: '#fff'
      },
      loading: true,
      bottomLoading: false,
      loadAll: false,
      order: [],
      themeColor: '#445FBB',
      page_num: 1,
      page_size: 10,
      postUrl: '',
      noMoreResult: false,
      menu: [],
      dropdownLock: false,
      filterParams: {
        order_type: '0',
        order_status: '0',
        time_type: '0'
      },
      // 当前筛选参数
      filters: []
    };
  },
  methods: {
    init(options) {
      getData({
        url: reqPathTo('consult/orderlist', options, '', 'law'),
        data: {
          vn: 'law',
          page_size: this.page_size,
          page_num: this.page_num,
          ...this.filterParams
        }
      }).then(data => {
        if (data && data.login + '' !== '1') {
          // 未登录先调登录
          act({
            type: 'login'
          });
        }
        data.filters.map(item => {
          item.column = Number(item.column);
          item.default_value = '';
          delete item.defaultValue;
          return item;
        });
        this.filters = data.filters;
        data.order = data.order_list;
        Object.assign(this, data);
        this._menu && (this.menu = this._menu);
        this.loading = false;
        this.page_num = this.page_num + 1;
      });
    },
    tapFn({
      target,
      type
    }, log) {
      act({
        target,
        type,
        log
      });
    },
    delCardFn(idx) {
      this.order.splice(idx, 1);
    },
    getAsyncOrders() {
      if (this.dropdownLock) {
        return;
      }
      this.dropdownLock = true;
      setTimeout(() => {
        this.dropdownLock = false;
      }, 300);
      this.bottomLoading = true;
      this.updateOrderList({
        isUpdate: false
      }).then(() => {
        this.bottomLoading = false;
      });
    },
    updateOrderList({
      isUpdate
    }) {
      if (isUpdate) {
        this.page_num = 1;
        this.page_size = 10;
      }
      // 异步请求咨询
      return this.requestData(isUpdate, reqPathTo('consult/orderlist', {}, '', 'law'));
    },
    requestData(isUpdate, url) {
      return request({
        url,
        data: {
          vn: 'law',
          page_size: this.page_size,
          page_num: this.page_num,
          ...this.filterParams
        }
      }).then(res => {
        try {
          let newOrder = res.data.data.order_list;
          if (!newOrder || newOrder.length === 0) {
            this.noMoreResult = true;
            this.bottomLoading = false;
          } else {
            this.page_num = this.page_num + 1;
          }
          this.order = isUpdate ? [...newOrder] : [...this.order, ...newOrder];
        } catch (e) {
          console.log(e); //eslint-disable-line
        }
      });
    },

    initPageData(options) {
      this.noMoreResult = false;
      this.order.length = 0;
      this.page_size = 10;
      // 获取参数
      const res = options.allResults;
      // 解析原始对象
      Object.keys(res).map(v => this.filterParams[v] = res[v].value ? res[v].value : this.filterParams[v]);
    },
    filterChangeFn(options) {
      if (this.bottomLoading) {
        return;
      }
      this.initPageData(options);
      // filter筛选
      this.loading = true;
      this.noMoreResult = false;
      this.updateOrderList({
        isUpdate: true
      }) // 筛选项修改刷新列表不是拼接
      .then(() => {
        this.loading = false;
      });
    },
    onReachBottom() {
      if (this.noMoreResult) {
        return;
      }
      this.getAsyncOrders();
    }
  },
  created() {
    (function (ctx) {
      this.init(ctx);
      this.$root.$emit("marsPageAfterCreated", this);
    }).call(this, this.$route.query);
  },
  mounted() {
    this.$nextTick(() => {
      (function () {
        this.$root.$emit("marsPageAfterMounted", this);
      }).call(this, this.$route.query);
    });
  },
  destroyed() {
    (function () {
      this.$root.$emit("marsPageAfterDestroyed", this);
    }).call(this, this.$route.query);
  },
  activated() {
    (function () {
      setPageInfoMenu({
        title: '律临法律服务_我的订单'
      });
      const commentindex = this.$api.getStorageSync('commentindex');
      if (commentindex) {
        const orderItem = this.order[Number(commentindex)];
        if (orderItem) {
          orderItem.btns[1].txt = '查看评价';
          this.order.splice(commentindex, 1, orderItem);
          this.$api.removeStorage({
            key: 'commentindex'
          });
        }
      }
      this.$root.$emit("marsPageAfterActivated", this);
    }).call(this, this.$route.query);
  },
  deactivated() {
    (function () {
      this.$root.$emit("marsPageAfterDeactivated", this);
    }).call(this, this.$route.query);
  }
};
</script>

<style scoped>
.expert-filters {
  position: fixed;
  z-index: 10;
  right: 0;
  left: 0;
}
.filters-box {
  width: 100%;
  height: 46px;
}
.order-wrapper .no-order {
  height: calc(100vh - 80px);
}
.order-wrapper .no-order-icon {
  font-size: 80px;
}
.order-wrapper .no-order-text {
  color: #333;
}
.loading {
  position: relative;
  top: 30px;
}
.bottom-loading-icon {
  width: 100px;
  height: 50px;
}

</style>
